<template>
  <div class="Untie">
    <Header msg='订单绑定' />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import { untieOrder, REQUEST_BASE } from '@/api';
import { Toast } from 'mint-ui';

export default {
  name: 'Untie',
  components: {
    Header
  },
  data() {
    return {
    }
  },
  created() {
    // console.log(this.$route.query);
    if (this.$route.query.uid) {
      sessionStorage.setItem('cww_unite_uid', this.$route.query.uid);
      this.$router.replace({path: `/Order`});
    } else {
      Toast({message: '请检查订单信息', className: 'iconfont icon-close'});
    };
    // return false;
    // if (this.$route.query.order_id) { 
    //   this.$router.replace({path: `/Confirmation?orderId=${this.$route.query.order_id}`});
    // } else {
    //   Toast({message: '请检查订单信息', className: 'iconfont icon-close'});
    //   setTimeout(() => {
    //     this.$router.replace({path: `/`});
    //   }, 2000);
    // }
  },
  mounted () {
  },
  methods: {
  },
  watch: {
  }
};
</script>

<style lang="less" scoped>
  .Untie{
    min-height: 100vh;
    font-size: 0;
  }
</style> 

